import {
  createApiClient,
//   handleGetRequest,
//   handlePostRequest,
} from "../apiService";
// import { useToken } from "../tokenUtils";

import { getSubdomain } from "../../utils/getSubdomain/subdomain";

const apiClient = createApiClient("/");
const domain = getSubdomain();

const login = async (): Promise<{url: string}> => {
  const res = await apiClient.get(`orcid/${domain}/login`);
  return res.data as {url: string};
};

const linkEmail = async (token: string, email: string): Promise<{message: string}> => {
  const res = await apiClient.post(`orcid/${domain}/link-email`, { token, email });
  return res.data as {message: string};
};

const verifyOrcid = async (token: string): Promise<{message: string, orcid: string}> => {
  // Se envía un string vacío en email para satisfacer el validador OrcidLinkEmailRequest del backend
  const res = await apiClient.post(`orcid/${domain}/verify-orcid`, { token, email: "" });
  return res.data as {message: string, orcid: string};
};

const orcidService = {
  login,
  linkEmail,
  verifyOrcid
};

export default orcidService;